import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import { useMyContext } from '../../../../context/MyContext';
import { FiLock, FiLink, FiExternalLink, FiCheck, FiAlertCircle } from 'react-icons/fi';
import { Base_Url ,woocomAuth } from '../../../../config/config';
import axios from 'axios';
export default function WooCommerceConnect() {
    const { isDarkMode, isToggleSidebar } = useMyContext();
    const [storeUrl, setStoreUrl] = useState('');
    const [touched, setTouched] = useState(false);
    const [fieldError, setFieldError] = useState('');
    const [hint, setHint] = useState('');

    const isValidUrl = (url) => {
        try {
            const urlObj = new URL(url);
            return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
        } catch {
            return false;
        }
    };

    const handleUrlChange = (e) => {
        const value = e.target.value;
        setStoreUrl(value);

        if (value && !isValidUrl(value)) {
            setFieldError('Please enter a valid URL starting with http:// or https://');
            setHint('');
        } else if (value && isValidUrl(value)) {
            setFieldError('');
            setHint('Looking good! Click connect to proceed.');
        } else {
            setFieldError('');
            setHint('');
        }
    };

 const handleSubmit = async (e) => {
  e.preventDefault();

  if (!isValidUrl(storeUrl)) return;

  try {
    const cus_id = localStorage.getItem("cus_id");
    const token = localStorage.getItem("token");

    const payload = {
      store_url: storeUrl,
      vendor_id: "211", // static as per your payload
    };

    const response = await axios.post(
      "YOUR_API_ENDPOINT_HERE",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          cus_id: cus_id,
          token: token, 
        },
      }
    );

  } catch (error) {
    console.error(
      "API Error:",
      error.response?.data || error.message
    );
  }
};


    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
            <div className="z-10 flex-shrink-0">
                <NavBar />
            </div>
            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                    <div
                        className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }>
                        <Sidebar />
                    </div>
                )}
                <div className="relative flex-1 flex items-center justify-center bg-white p-3 sm:p-4 md:p-6 lg:p-8 overflow-hidden">
                    {/* Purple glow background */}
                    <div className="pointer-events-none absolute flex items-center justify-center">
                        <div className="text-[8rem] sm:text-[12rem] md:text-[16rem] lg:text-[20rem] font-black opacity-[0.02] select-none text-purple-900">PX</div>
                    </div>

                    {/* Improved animated radiant blobs */}
                    <div className="pointer-events-none absolute inset-0">
                        <div className="absolute -top-20 sm:-top-32 md:-top-40 -left-16 sm:-left-24 md:-left-32 h-40 w-40 sm:h-56 sm:w-56 md:h-72 md:w-72 rounded-full bg-white blur-2xl sm:blur-3xl animate-pulse" />
                        <div className="absolute -bottom-20 sm:-bottom-32 md:-bottom-40 -right-16 sm:-right-24 md:-right-32 h-48 w-48 sm:h-64 sm:w-64 md:h-80 md:w-80 rounded-full bg-white blur-2xl sm:blur-3xl animate-pulse" style={{ animationDuration: '4s' }} />
                        <div className="absolute top-1/2 -right-20 sm:-right-32 md:-right-40 h-40 w-40 sm:h-52 sm:w-52 md:h-64 md:w-64 rounded-full bg-white blur-[60px] sm:blur-[80px] animate-pulse" style={{ animationDuration: '6s' }} />
                    </div>

                    <motion.div
                        className="w-full max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 md:gap-6 lg:gap-8 items-center"
                        initial={{ opacity: 0, y: 22 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        {/* LEFT INFO CARD */}
                        <motion.div
                            className="relative rounded-2xl sm:rounded-3xl p-3 sm:p-4 md:p-6 lg:p-8 shadow-xl sm:shadow-2xl border border-gray-200 bg-white"
                            initial={{ x: -40, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.2 }}
                        >
                            <div className="flex items-start gap-2 sm:gap-3">
                                <div className="relative flex-shrink-0">
                                    <div className="absolute inset-0 rounded-xl sm:rounded-2xl bg-purple-300/30 blur-lg sm:blur-xl" />
                                    <div className="relative h-8 w-8 sm:h-10 sm:w-10 md:h-12 md:w-12 rounded-xl sm:rounded-2xl bg-gradient-to-br from-purple-100 to-fuchsia-100 border border-purple-200 flex items-center justify-center">
                                        <div className="h-6 w-6 sm:h-7 sm:w-7 md:h-8 md:w-8 bg-gradient-to-br from-purple-600 to-fuchsia-500 rounded-lg sm:rounded-xl flex items-center justify-center text-white font-bold text-[10px] sm:text-xs">
                                            PX
                                        </div>
                                    </div>
                                </div>

                                <div className="flex-1 min-w-0">
                                    <h1 className="text-sm sm:text-base md:text-lg lg:text-xl font-bold tracking-tight text-gray-900 break-words">
                                        Connect Your WooCommerce Store
                                    </h1>
                                    <p className="text-[10px] sm:text-xs text-gray-600 mt-0.5 sm:mt-1">
                                        Sync orders, automate shipping, and track deliveries with PickupXpress.
                                    </p>
                                </div>
                            </div>

                            <div className="mt-3 sm:mt-4 md:mt-5 lg:mt-6 space-y-1.5 sm:space-y-2 md:space-y-3">
                                {[
                                    "Enter your WooCommerce store URL.",
                                    "Approve secure access on your WordPress admin.",
                                    "We auto-sync your WooCommerce orders.",
                                    "Ship and track directly from PickupXpress.",
                                    "Keep customers updated with real-time tracking.",
                                ].map((step, i) => (
                                    <div key={i} className="flex gap-2 sm:gap-3 items-start">
                                        <div className="mt-0.5 flex-shrink-0 h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 rounded-full bg-purple-100 border border-purple-300 flex items-center justify-center text-[10px] sm:text-xs font-semibold text-purple-700">
                                            {i + 1}
                                        </div>
                                        <p className="text-[10px] sm:text-xs text-gray-700 leading-relaxed">{step}</p>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-3 sm:mt-4 md:mt-5 lg:mt-6 flex items-start sm:items-center gap-2 text-[10px] sm:text-xs text-gray-600">
                                <FiLock className="text-purple-600 flex-shrink-0 mt-0.5 sm:mt-0" size={12} />
                                <span>You can revoke access anytime from your WooCommerce store.</span>
                            </div>
                        </motion.div>

                        {/* RIGHT FORM CARD */}
                        <motion.div
                            className="relative rounded-2xl sm:rounded-3xl p-3 sm:p-4 md:p-6 lg:p-8 bg-white border border-gray-200 shadow-xl sm:shadow-2xl"
                            initial={{ x: 40, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.3 }}
                        >
                            <div className="space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-6">
                                <div>
                                    <div className="inline-flex items-center gap-1.5 sm:gap-2 px-2 sm:px-2.5 md:px-3 py-0.5 sm:py-1 rounded-full bg-purple-50 border border-purple-200 text-purple-700 mb-2 sm:mb-3">
                                        <div className="h-2.5 w-2.5 sm:h-3 sm:w-3 bg-purple-100 rounded-full flex items-center justify-center">
                                            <FiLink size={6} className="text-purple-600 sm:w-2 sm:h-2" />
                                        </div>
                                        <span className="text-[9px] sm:text-[10px] md:text-xs">WooCommerce Secure Connect</span>
                                    </div>

                                    <h2 className="text-sm sm:text-base md:text-lg font-semibold text-gray-900">Seller Panel</h2>
                                    <p className="text-[10px] sm:text-xs text-gray-600 mt-0.5 sm:mt-1">
                                        Enter your WooCommerce URL and follow the approval step.
                                    </p>
                                </div>

                                <div className="space-y-1.5 sm:space-y-2">
                                    <label className="block text-[9px] sm:text-[10px] md:text-xs font-medium uppercase tracking-wide text-gray-600">
                                        Store URL
                                    </label>

                                    <div className="relative group">
                                        <FiExternalLink className="absolute left-2.5 sm:left-3 top-2 sm:top-2.5 text-gray-400 text-xs sm:text-sm" />
                                        <input
                                            type="text"
                                            value={storeUrl}
                                            onChange={handleUrlChange}
                                            onBlur={() => setTouched(true)}
                                            placeholder="https://yourstore.com"
                                            className={`w-full bg-gray-50 text-gray-900 rounded-xl pl-8 sm:pl-10 pr-8 sm:pr-10 py-1.5 sm:py-2 outline-none border text-[10px] sm:text-xs placeholder:text-gray-400 transition-all
                                        ${touched && fieldError
                                                    ? "border-red-400 shadow-[0_0_0_1px_rgba(248,113,113,0.7)]"
                                                    : touched && isValidUrl(storeUrl)
                                                        ? "border-purple-500 shadow-[0_0_0_1px_rgba(147,51,234,0.5)]"
                                                        : "border-gray-300 focus:border-purple-500 focus:shadow-[0_0_0_1px_rgba(147,51,234,0.5)]"
                                                }`}
                                        />

                                        {touched && (
                                            <div className="absolute right-2.5 sm:right-3 top-1.5 sm:top-2">
                                                {isValidUrl(storeUrl) ? (
                                                    <FiCheck className="text-purple-600 text-xs sm:text-sm" />
                                                ) : fieldError ? (
                                                    <FiAlertCircle className="text-red-500 text-xs sm:text-sm" />
                                                ) : null}
                                            </div>
                                        )}
                                    </div>

                                    {fieldError && (
                                        <p className="text-[10px] sm:text-xs text-red-600 flex items-center gap-1">
                                            <FiAlertCircle size={10} className="sm:w-3 sm:h-3" /> {fieldError}
                                        </p>
                                    )}

                                    {!fieldError && hint && (
                                        <p className="text-[10px] sm:text-xs text-purple-600">{hint}</p>
                                    )}
                                </div>

                                <motion.button
                                    type="button"
                                    onClick={handleSubmit}
                                    disabled={!isValidUrl(storeUrl)}
                                    whileHover={{ scale: isValidUrl(storeUrl) ? 1.02 : 1 }}
                                    whileTap={{ scale: isValidUrl(storeUrl) ? 0.97 : 1 }}
                                    className="w-full rounded-xl bg-gradient-to-r from-purple-600 via-fuchsia-500 to-purple-600 text-white py-2 sm:py-2.5 text-[10px] sm:text-xs md:text-sm font-semibold flex items-center justify-center gap-1.5 sm:gap-2 shadow-lg disabled:opacity-40 disabled:cursor-not-allowed transition-all hover:shadow-xl"
                                >
                                    <FiLink size={12} className="sm:w-3.5 sm:h-3.5" />
                                    <span>Connect to WooCommerce</span>
                                </motion.button>

                                <div className="border-t border-gray-200 pt-2.5 sm:pt-3 md:pt-4 text-[10px] sm:text-xs text-gray-600">
                                    <div className="flex items-start sm:items-center gap-1.5 sm:gap-2">
                                        <FiLock className="text-purple-600 flex-shrink-0 mt-0.5 sm:mt-0" size={10} />
                                        <span>PickupXpress never asks for your WordPress password.</span>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
            </div>
        </div>
    );
}